import React, { useState, useEffect, useRef } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ATitle from "core/presentation/components/Title";
import { Select } from "antd";
import AText from "core/presentation/components/Text";
import { color } from "theme/Color";
import "./chart.css";
import PieChart from "core/presentation/components/PieChartComponent";
import { useAppSelector } from "core/presentation/store/hooks";
import Loader from "core/presentation/components/Loader";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);
const { Option } = Select;

type FilterType = "Monthly" | "Yearly";

export function Summary() {
  const [filter, setFilter] = useState<FilterType>("Monthly");
  const legendRef = useRef<HTMLDivElement>(null);

  const { dashboardData } = useAppSelector((state) => state.user);

  // const dashboardData = {
  //   summary: {
  //     vehicleOwner: {
  //       Active: 10,
  //       Inactive: 10,
  //     },
  //     shipper: {
  //       Active: 7,
  //       Inactive: 7,
  //     },
  //     driver: {
  //       Active: 3,
  //       Inactive: 8,
  //     },
  //   },
  //   noOfVehicles: {
  //     convertedVehicleData: {
  //       InJob: 0,
  //       Available: 3,
  //       Total: 6,
  //       Others: 3,
  //     },
  //   },
  //   deliveryRate: {
  //     convertedDeliveryRateData: {
  //       totalRequest: 0,
  //       onTime: 0,
  //       delayed: 0,
  //     },
  //   },
  // };

  const handleFilterChange = (value: FilterType) => {
    setFilter(value);
  };

  const extractDataOld = (summary: any) => {
    const labels = Object.keys(summary.vehicleOwner);
    const userTypes = Object.keys(summary);

    const datasets = userTypes.map((userType) => ({
      label: userType.charAt(0).toUpperCase() + userType.slice(1),
      data: labels.map((label) => summary[userType][label]),
      backgroundColor: ["#98C971", "#04BFDA"],
      borderWidth: 1,
    }));
    return { labels, datasets };
  };

  const extractData = (summary: any) => {
    const labels = Object.keys(summary.vehicleOwner);
    const userTypes = Object.keys(summary);

    const datasets = userTypes.map((userType) => {
      const activeCount = parseInt(summary[userType]["Active"], 10);
      const inactiveCount = parseInt(summary[userType]["Inactive"], 10);
      const totalCount = activeCount + inactiveCount;

      // Calculate percentages
      const activePercentage = ((activeCount / totalCount) * 100).toFixed(0);
      const inactivePercentage = ((inactiveCount / totalCount) * 100).toFixed(
        0
      );

      return {
        label: userType.charAt(0).toUpperCase() + userType.slice(1),
        data: [parseFloat(activePercentage), parseFloat(inactivePercentage)],
        backgroundColor: ["#98C971", "#04BFDA"],
        borderWidth: 1,
      };
    });

    return { labels, datasets };
  };

  const { labels, datasets }: any = extractData(dashboardData?.summary);

  const data: any = {
    labels,
    datasets,
  };

  const options = {
    plugins: {
      datalabels: {
        color: "#ffffff",
        font: {
          weight: 500,
          size: 12,
        },
        formatter: (value: any) => {
          return value + "%";
        },
        anchor: "center" as const,
        align: "center" as const,
        offset: 0,
      },
      legend: {
        display: false, // Disable the default legend
      },
    },
  };

  useEffect(() => {
    if (legendRef.current) {
      const legendItems = data?.labels
        .map((label: any, index: number) => {
          const color = data?.datasets[0]?.backgroundColor[index];
          return `
          <li>
            <span class="legend-circle" style="background-color: ${color}"></span>
            ${label}
          </li>
        `;
        })
        .join("");
      legendRef.current.innerHTML = `<ul class="custom-legend">${legendItems}</ul>`;
    }
  }, [data]);

  if (!dashboardData) {
    return <Loader />;
  }
  return (
    <>
      <ATitle
        content="Summary"
        fontSize={22}
        fontWeight={700}
        marginTop="40px"
        lineHeight={"30px"}
      />

      <div
        style={{
          padding: "30px",
          border: "1px solid #EAECF0",
          margin: "30px 0",
          borderRadius: "8px",
          background: "#fff",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            // marginRight: "20px",
          }}
        >
          <Select
            defaultValue="Monthly"
            style={{ fontSize: "12px", fontWeight: 600 }}
            onChange={handleFilterChange}
          >
            <Option value="Monthly">Monthly</Option>
            <Option value="Yearly">Yearly</Option>
          </Select>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "20px",
          }}
        >
          <div style={{ width: "30%" }}>
            <AText fontSize={16} fontWeight={600} mode="black">
              Vehicle Owner
            </AText>
            <PieChart
              data={{ ...data, datasets: [data?.datasets[0]] }}
              options={options}
            />
          </div>
          <div style={{ width: "30%" }}>
            <AText fontSize={16} fontWeight={600} mode="black">
              Shipper
            </AText>
            <PieChart
              data={{ ...data, datasets: [data?.datasets[1]] }}
              options={options}
            />
          </div>
          <div style={{ width: "30%" }}>
            <AText fontSize={16} fontWeight={600} mode="black">
              Driver
            </AText>
            <PieChart
              data={{ ...data, datasets: [data?.datasets[2]] }}
              options={options}
            />
          </div>
        </div>

        <div
          ref={legendRef}
          style={{ textAlign: "left", marginTop: "20px" }}
        ></div>
      </div>
    </>
  );
}
